import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronDown, ChevronRight } from "react-bootstrap-icons";
import sideBarImg from "../../assets/icons/sidebar/icon-sidebar-button.png";
import AuthenticationService from "../../services/AuthenticationService";
import MessageAlert from "../../components/MessageAlert/MessageAlert";
import * as getUserInfo from "../../actions/GetUserInfo.action"
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import "./sidebar.css";
import ContractorBillingService from "../../services/ContractorBillingService";
import appSettings from "../../utils/AppSetting";
import * as Constants from "../../utils/Constants";

export default function Sidebar({ setUserData, userData }) {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const authenticationService = AuthenticationService();
  const contractorBillingService = ContractorBillingService();
  const chiefNo = JSON.parse(localStorage.getItem("chiefNo")) || "";
  // const applNo = appSettings.application.appNo || "";
  const applNo = `${appSettings.services.application.appNo}`;

const data = {
  chiefNo: chiefNo,
  applNo:applNo
};

const [menuData, setMenuData] = useState(
  // JSON.parse(localStorage.getItem("menuData"))
);


  const [isOpen, setIsOpen] = useState(false);
  const { t, i18n } = useTranslation();
  
  const fetchData = async (param) => {
    try {
      // if(!chiefNo || chiefNo === ""){
      //   chiefNo = localStorage.getItem("chiefNo");
      //   chiefNo = chiefNo.replace(/"/g, "");
      // }


      const response = await contractorBillingService.ListMenu({username:chiefNo ,applNo:applNo});   

      dispatch(getUserInfo.GetUserInformation(response))
      if (response.isSuccess) {        
        setMenuData(response?.result?.menuList);
        setUserData(response?.result);
        localStorage.setItem("menuData", JSON.stringify(response?.result?.menuList));
        localStorage.setItem("userData", JSON.stringify(response?.result));
        localStorage.setItem("islogin", true);

        let lang = ((response?.result?.lang) ? response?.result?.lang?.split("-")[0] : Constants.Language.Thai); 
        i18n.changeLanguage(lang); // set ภาษาตาม user ที่เข้ามา >> หากไม่มี default TH

      } 
      else if (response.statusCode === Constants.StatusCode.UserNotFound || !response.isSuccess) {
        MessageAlert.warning({
          title: "แจ้งเตือน",
          message: "ไม่พบข้อมูล Users ",
         // navigate: "http://qsson-19c.homepro.local/",
        });
      }
    } catch (error) {
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSubItemClick = (url, e) => {
    e.stopPropagation();

    if (url) {
      const getCurrentPath = () => {
        const isLocalhost = window.location.origin.includes("localhost:3000");
        return isLocalhost ? "" : "";
      };
      const basePath = getCurrentPath();
      const finalUrl = `${basePath}${url}`;
      navigate(finalUrl);
    }
  };

  const handleExpand = (index, e, item) => {
    e.stopPropagation();
    if (item.subMenuList.length === 0) {
      const getCurrentPath = () => {
        const isLocalhost = window.location.origin.includes("localhost:3000");
        return isLocalhost ? "" : "";
      };

      const basePath = getCurrentPath();
      const finalUrl = `${basePath}${item?.relativePath}`;
      navigate(finalUrl);
    } else {
      const newMenuData = [...menuData];
      newMenuData[index].isOpen = !newMenuData[index].isOpen;
      setMenuData(newMenuData);
    }
  };
  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={isOpen ? "sideBar-Container" : "sideBar-Container close"} >
      <div className="sideBar-Layout">
        <div className={isOpen ? "sideBar-Button" : "sideBar-Button close"}
          onClick={handleClick}
        >
          <ChevronRight style={{ fontSize: '25px' }} />
        </div>
        <div className="sideBarMainMenu1">
          {menuData?.map((item, index) => {
            return (
              item.funcNo.length === 3 &&
              (
                <div
                  key={index}
                  className={`menu-item ${item.isOpen ? "open" : ""}`}
                  onClick={(e) => handleExpand(index, e, item)}
                >
                  {item?.funcName}
                  {item?.subMenuList &&
                    item?.subMenuList.length > 0 &&
                    (item?.isOpen ? (
                      <ChevronDown size={15} className="menu-chevron" />
                    ) : (
                      <ChevronRight size={15} className="menu-chevron" />
                    ))}
                  {item?.isOpen && item.subMenuList && (
                    <div className="submenu">
                      {item?.subMenuList?.map((sub, subIndex) => (
                        <div
                          key={subIndex}
                          className="sub-item"
                          onClick={(e) =>
                            handleSubItemClick(sub.relativePath, e)
                          }
                        >
                          {sub?.funcName}
                          {sub?.sub2MenuList && (
                            <div className="sub2menu">
                              {sub?.sub2MenuList.map((sub2, sub2Index) => (
                                <div key={sub2Index} className="sub2-item">
                                  {sub2?.funcName}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )
            );
          })}
        </div>
      </div>
    </div>
  );
}
